import { render, staticRenderFns } from "./ColorButton.vue?vue&type=template&id=26fbd57f&"
import script from "./ColorButton.vue?vue&type=script&lang=js&"
export * from "./ColorButton.vue?vue&type=script&lang=js&"
import style0 from "./ColorButton.vue?vue&type=style&index=0&id=26fbd57f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports